class Menu {

    constructor() {
        this.openerButtons        = document.querySelectorAll('.js-navOpen');
        this.closeButton          = document.querySelector('.js-navClose');
        this.mobileButton         = document.querySelector('#navOpener');
        this.backButtons          = document.querySelectorAll('.navDrop__back');
        this.navDrop              = document.querySelector('#navDrop');
        this.accordions           = this.navDrop.querySelectorAll('#navDrop .js-accordion');
        this.columns              = document.querySelectorAll('.navDrop__column');
        this.firstColumn          = document.querySelector('.navDrop__column--l1');
        this.lastColumn           = document.querySelector('.navDrop__column--l2');
        this.currentItems         = document.querySelectorAll('.navDrop__item.cur')
        this.currentItem          = this.currentItems[this.currentItems.length - 1];
        this.currentItemMobile    = this.currentItems[0];
        this.currentNav           = this.currentItem ? this.currentItem.closest('.navDrop__nav') : false;
        this.currentNavMobile     = this.currentItemMobile ? this.currentItemMobile.closest('.navDrop__nav') : false;
        this.currentColumn        = this.currentItem ? this.currentItem.closest('.navDrop__column') : false;
        this.currentColumnMobile  = this.currentItemMobile ? this.currentItemMobile.closest('.navDrop__column') : false;
        this.currentNavIndex      = this.currentNav ? this.currentNav.dataset.root : false;
        this.navNavs              = document.querySelectorAll('.navDrop__nav');  
        this.activeAccordion      = document.querySelector('.navDrop__column--l2 .navDrop__item.act .navDrop__itemAccordion');
        this.activePages          = document.querySelectorAll('.navDrop__item.act');
        this.accordionButton      = this.activeAccordion?.querySelector('[aria-expanded]');     
        this.teasers              = document.querySelectorAll('.navDrop__teasers');
        this.deviceBreakpoint     = 1199;
        this.mobileClickHandler   = this.mobile_click.bind(this);
        this.desktopClickHandler  = this.desktop_click.bind(this);
    }


    closeNav() {
        document.body.classList.remove('js-navOpened');
        document.body.classList.add('js-animation');
        this.closeAll();
        this.closeAccordions();

        setTimeout(() => {
            document.body.classList.remove('js-animation');
        }, 500);
    }


    listener_closeNav() {
        this.closeButton.addEventListener('click', () => {     
            this.closeNav();
        });

        document.addEventListener('mouseup', (event) => {
            const container = document.querySelector('.navDrop__container');
            const headerNav = document.querySelector('.navHeader__list');

            if (!container.contains(event.target) && !headerNav.contains(event.target) && !this.mobileButton.contains(event.target)) {
                this.closeNav();
            }
        });
    }

    
    listener_openNav() {
        this.openerButtons.forEach((element) => {
            element.addEventListener('click', () => {
                if (!document.body.classList.contains('js-navOpened')) {
                    document.body.classList.add('js-animation');
                    document.body.classList.add('js-navOpened');
                    setTimeout(() => {
                        document.body.classList.remove('js-animation');
                    }, 500);
                } 
            });
        });
    }


    mobile_click(event) {
        const clickedLink  = event.target.closest('.js-next') || event.target.classList.contains('js-next');
            
        if (!clickedLink) return;

        const targetMenu = clickedLink.dataset.targetid;

        targetMenu && this.showSubMenu(targetMenu);
    }


    desktop_click(event) {
        const clickedLink  = event.target.closest('.js-next') || 
                             event.target.classList.contains('js-next') || 
                             event.target.closest('.js-next-desktop') || 
                             event.target.classList.contains('js-next-desktop');
            
        if (!clickedLink) return;

        const clickedIndex    = clickedLink.dataset.index;
        const targetMenu      = clickedLink.dataset.targetid;
        const isLevel1        = clickedLink.closest('.nav--level1');
 

        // open submenu if on subpage
        if ((isLevel1) && (this.currentItem) && (clickedIndex === this.currentNavIndex)) {

            this.closeAll();
            this.showActiveMenus();
            this.toggleTeasers(clickedIndex);
        } 
        
        else {
            this.hideSubMenus(3);

            targetMenu && this.showSubMenu(targetMenu);

            if (clickedLink.classList.contains('navHeader__link')) {
                this.showFirstSubMenu();
                this.toggleTeasers(clickedIndex);
            }                
        }
    }


    setDevice() {
        document.body.classList.remove('js-navMobile', 'js-navDesktop');

        if (this.deviceBreakpoint >= window.innerWidth) {
            this.closeNav();
            document.body.classList.add('js-navMobile');
            document.removeEventListener('click', this.desktopClickHandler);
            document.addEventListener('click', this.mobileClickHandler);
        } else {
            this.closeNav();
            document.body.classList.add('js-navDesktop');
            document.removeEventListener('click', this.mobileClickHandler);
            document.addEventListener('click', this.desktopClickHandler);
        }
    }


    // prevent multiple resize triggers
    listener_device() {
        let ok_to_resize = true;
        window.addEventListener('resize', () => {
            if (ok_to_resize){    
                this.setDevice();
                ok_to_resize = false;
                setTimeout( () => {
                    ok_to_resize = true;
                }, 100);
            }
        });
    }


    hideSubMenus = (level) => {

        const navs = document.querySelectorAll(level ? `.navLevel${level}` : '.navDrop__nav');

        navs.forEach( (element) => {
            element.classList.remove('js-active');
        })
    }


    showSubMenu = (subId) => {

        const targetMenu   = document.getElementById(subId);
        const targetColumn = targetMenu.parentElement;
        const sibblings    = Array.from(targetMenu.parentNode.children);

        sibblings.forEach( (item) => {
            item.classList.remove('js-active');
        })

        this.columns.forEach( (item) => {
            item.classList.remove('js-active');
        })

        targetMenu.classList.add('js-active');

        if (targetColumn) {
            targetColumn.classList.add('js-active');
        }
    }


    closeAccordions() {
        this.accordions.forEach( (element) => {
            element.classList.remove('js-accordion--opened');
            element.setAttribute('aria-expanded', false);
            element.lastChild.setAttribute('inert', '');
        })
    }


    showActiveMenus() {
        const targetMenu      = this.currentItem.querySelector('.navDrop__itemTitle') ? this.currentItem.querySelector('.navDrop__itemTitle').dataset.targetid : false;
        const navOpened       = document.body.classList.contains('js-navOpened');
        const navAnimated     = document.body.classList.contains('js-animation');
        const delay           = (navOpened && !navAnimated) ? 0 : 1000;
        
        this.activePages.forEach( (item) => {

            const parentNav =    item.closest('.navDrop__nav');
            const parentColumn = item.closest('.navDrop__column');

            if(parentNav && parentColumn) {

                const _delay = (parentNav.classList.contains('navLevel2')) ? 0 : delay;

                setTimeout(() => {
                    parentNav.classList.add('js-active');
                    parentColumn.classList.add('js-active');
                }, _delay);
            }     
        });

        this.closeAccordions();

        setTimeout(() => {
            this.activeAccordion.classList.add('js-accordion--opened');
            this.activeAccordion.lastChild.removeAttribute('inert');
            this.accordionButton.setAttribute('aria-expanded', true);
            
            targetMenu && this.showSubMenu(targetMenu);
        }, delay);
    }


    showFirstSubMenu() {
        const firstAccordion       = document.querySelector('.navDrop__column--l2 .navDrop__nav.js-active .navDrop__itemAccordion');
        const firstAccordionButton = firstAccordion?.querySelector('[aria-expanded]');
        const subMenu              = firstAccordionButton?.dataset.targetid; 
        const navOpened            = document.body.classList.contains('js-navOpened');
        const navAnimated          = document.body.classList.contains('js-animation');
        const delay                = (navOpened && !navAnimated) ? 0 : 1000;

        this.closeAccordions();

        setTimeout(() => {
            firstAccordion.lastChild.removeAttribute('inert');
            firstAccordion.classList.add('js-accordion--opened');
            firstAccordionButton.setAttribute('aria-expanded', true);
            subMenu && this.showSubMenu(subMenu);
        }, delay);
    }


    toggleTeasers(index) {
        const activeTeaser = document.querySelector(`#navDrop__teasers${index}`);
        const navOpened    = document.body.classList.contains('js-navOpened');
        const navAnimated  = document.body.classList.contains('js-animation');
        const delay        = (navOpened && !navAnimated) ? 0 : 1600;

        this.teasers.forEach( (element) => {
            element.classList.remove('js-active');
        })

        setTimeout(() => {
            activeTeaser?.classList.add('js-active');
        }, delay);
    }


    closeAll() {
        this.columns.forEach( (item) => {
            item.classList.remove('js-active');
        })

        this.navNavs.forEach( (item) => {
            item.classList.remove('js-active');
        });
    }


    listener_toggleMobileNav() {
        this.mobileButton.addEventListener('click', () => {

            const navOpened      = document.body.classList.contains('js-navOpened');

            if (navOpened) {
                this.closeAll();
                this.closeAccordions();
                document.body.classList.remove('js-navOpened');
            } else {
                document.body.classList.add('js-navOpened');

                if (this.currentItem) {
                    this.currentNavMobile.classList.add('js-active');
                    this.currentColumnMobile.classList.add('js-active');
                    this.activeAccordion.classList.add('js-accordion--opened');
                    this.accordionButton.setAttribute('aria-expanded', true);
                } else {
                    setTimeout(() => {
                        this.firstColumn.classList.add('js-active');
                    }, 500);
                }
            }
        })
    }


    listener_backNav() {

        this.backButtons.forEach( (element) => {
            element.addEventListener('click', () => {
                this.closeAll();
                this.closeAccordions();
                this.firstColumn.classList.add('js-active');
            })
        })
    }

    
    init(){
        this.setDevice();
        this.listener_device();
        this.listener_openNav();
        this.listener_closeNav();
        this.listener_toggleMobileNav();
        this.listener_backNav();
    }
}


export const initMenu = () => {

    const newMenu = new Menu();
    newMenu.init();
}
